import {Injectable, Injector} from "@angular/core";
import {ReportError} from "app/app.service";

import {BaseListService} from "app/services/domain/base.service";
import * as Models from "app/services/proxy/model/models";
import {Transforms} from "app/shared/utils/transforms";
import {UtilsService} from "framework/services/utils.service";
import {ControlOption} from "framework/ui/control-option";

@Injectable()
export class CmdbSyncLogsService extends BaseListService<Models.ServiceNowCmdbSyncLogListRequest, Models.BatchRequest, Models.ServiceNowCmdbSyncLog>
{
    constructor(inj: Injector)
    {
        super(inj, Models.ServiceNowCmdbSyncLog);
    }

    @ReportError
    public list(listReq: Models.ServiceNowCmdbSyncLogListRequest): Promise<Models.ListResponse>
    {
        return this.domain.apis.serviceNowIntegrationsApi.serviceNowCMDBSyncLogsList(listReq);
    }


    @ReportError
    protected async getBatchResponseImpl(req: Models.BatchRequest): Promise<Models.ServiceNowCmdbSyncLogBatchResponse>
    {
        const recordIdBatchRequest = Models.BatchRequest.newInstance(req);

        return this.domain.apis.serviceNowIntegrationsApi.serviceNowCMDBSyncLogsBatch(recordIdBatchRequest);

    }


    protected createBatchRequest(listReq: Models.ServiceNowCmdbSyncLogListRequest,
                                 ids: string[]): Models.BatchRequest
    {
        return Models.BatchRequest.newInstance({ids: ids});
    }

    public getProviderNativeDetails(provider: Models.CloudServiceName): Models.ServiceAccountNativeDetailsBase
    {
        switch (provider)
        {
            case Models.CloudServiceName.AWS:
                return new Models.ServiceAccountNativeDetailsBaseForAws();

            case Models.CloudServiceName.Azure:
                return new Models.ServiceAccountNativeDetailsBaseForAzure();

            case Models.CloudServiceName.GCP:
                return new Models.ServiceAccountNativeDetailsBaseForGcp();

            case Models.CloudServiceName.OCI:
                return new Models.ServiceAccountNativeDetailsForOciTenancy();

            default:
                return null;
        }
    }

    getCmdbScope(selectedScope: Models.ServiceNowCmdbScope): string
    {
        if (selectedScope == Models.ServiceNowCmdbScope.master_account)
        {
            return "Account";
        }
        else
        {
            let scope: string = UtilsService.replaceAll(selectedScope.toString(), "_", " ");
            scope             = UtilsService.capitalizeFirstLetterAllWords(scope);
            return scope;
        }
    }

    @ReportError
    public async getServiceAccountListFromSelectedProvider(nativeDetails: Models.ServiceAccountNativeDetailsBase[],
                                                           byMasterAccount: boolean,
                                                           showInactive: boolean = false,
                                                           tenant?: string): Promise<ControlOption<string>[]>
    {
        const statuses = [
            Models.ServiceAccountStatus.active
        ];
        if (showInactive)
        {
            statuses.push(Models.ServiceAccountStatus.inactive);
        }
        const filters = Models.ServiceAccountFilter.newInstance({
                                                                    native_details: nativeDetails,
                                                                    statuses      : statuses
                                                                });

        const tenantId = tenant || this.app.domain.users.lastActiveTenantId;
        if (byMasterAccount)
        {
            filters.master_account_ids = [this.app.domain.users.masterAccountId];
        }
        else
        {
            filters.tenant_ids = [tenantId];
        }
        const reqBody = Models.ServiceAccountListRequest.newInstance({
                                                                         filters: filters
                                                                     });

        const overAllList = await this.app.domain.accountGovernanceList.listAll(reqBody);
        return await this.getServiceAccountOptionsFromSelectedProvider(overAllList);
    }

    @ReportError
    public async getServiceAccountOptionsFromSelectedProvider(ids: string[],
                                                              accountId?: string,
                                                              feature?: Models.ServiceAccountFeature): Promise<ControlOption<string>[]>
    {
        const req = Models.ServiceAccountBatchRequest.newInstance({ids: Transforms.mapToRecordIdentities(ids)});
        const batch                                  = await this.app.domain.accountGovernanceList.batchAsLookup(req);
        let batchResultsArr: ControlOption<string>[] = [];
        for (let id of ids)
        {
            if (accountId && feature)
            {
                const featureState = batch[id]?.onboarded_features.find(obj => (obj?.feature == feature && obj.tool_account_id == accountId));
                if (!featureState) continue;
            }

            batchResultsArr.push(new ControlOption<string>(id, batch[id]?.name));
        }
        return batchResultsArr;
    }
}
